<template>
  <div class="">
    <!-- Header and Add Button -->
    <div class="flex flex-col md:flex-row md:items-center md:justify-between mb-4 gap-4">
      <div class="flex items-center gap-2">
        <h2 class="text-xl font-semibold text-gray-800">List of Promotions</h2>
      </div>
      <button
        @click="OpenAddDataModal"
        class="flex items-center gap-2 bg-blue-800 hover:bg-blue-900 text-white font-semibold px-3 py-2 rounded-lg shadow transition"
      >
        <span class="material-icons text-base">add</span>
        Add Promotion
      </button>
    </div>
    <!-- Filter Bar -->
    <div class="flex flex-wrap items-center justify-between gap-2 mb-4">
      <div class="flex bg-gray-200 rounded-lg">
        <button
          :class="[
            'px-4 py-2 font-medium focus:outline-none transition select-none',
            search.is_active === '' ? 'bg-white text-indigo-700 font-semibold shadow-md rounded-lg z-10' : 'text-gray-600 hover:bg-gray-200',
          ]"
          @click="
            search.is_active = '';
            fetchAllPromotionData();
          "
        >
          All
        </button>
        <button
          :class="[
            'px-4 py-2 font-medium focus:outline-none transition select-none',
            search.is_active === 'active' ? 'bg-white text-indigo-700 font-semibold shadow-md rounded-lg z-10' : 'text-gray-600 hover:bg-gray-200',
          ]"
          @click="
            search.is_active = 'active';
            fetchAllPromotionData();
          "
        >
          Active
        </button>
        <button
          :class="[
            'px-4 py-2 font-medium focus:outline-none transition select-none',
            search.is_active === 'inactive'
              ? 'bg-white text-indigo-700 font-semibold shadow-md rounded-lg z-10'
              : 'text-gray-600 hover:bg-gray-inactive00',
          ]"
          @click="
            search.is_active = 'inactive';
            fetchAllPromotionData();
          "
        >
          Inactive
        </button>
      </div>
      <!--  Search and Sort Controls -->
      <div class="flex items-center gap-2">
        <vs-select v-model="search.app_language" @change="fetchAllPromotionData" class="mt-1.5" :color="'#6366f1'">
          <vs-select-item value="all" text="Language" disabled />
          <vs-select-item v-for="lang in languages" :key="lang.culture" :value="lang.culture" :text="lang.culture" />
        </vs-select>
        <vs-input class="" label="Start Date" type="date" v-model="search.start_date" @change="fetchAllPromotionData" />
        <vs-input label="End Date" type="date" v-model="search.end_date" @change="fetchAllPromotionData" />
        <button
          @click="resetData()"
          class="flex items-center gap-1 bg-yellow-500 hover:bg-yellow-600 text-white px-4 py-2 rounded-lg font-medium transition mt-1.5"
        >
          <span class="material-icons text-base">refresh</span> Reset
        </button>
      </div>
    </div>
    <!-- Table -->
    <div class="overflow-x-auto rounded-xl border border-gray-200 bg-white pb-2">
      <table class="min-w-full bg-white rounded-xl">
        <thead class="border-b">
          <tr>
            <th class="px-4 py-3 text-xs font-semibold text-gray-500 uppercase">#</th>
            <th class="px-4 py-3"></th>
            <th class="px-4 py-3 text-xs font-semibold text-gray-500 uppercase">Title</th>
            <th class="px-4 py-3 text-xs text-center font-semibold text-gray-500 uppercase">Language</th>
            <th class="px-4 py-3 text-xs text-center font-semibold text-gray-500 uppercase">Period</th>
            <th class="px-4 py-3 text-xs text-center font-semibold text-gray-500 uppercase">Status</th>
            <th class="px-4 py-3"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, idx) in promotionData" :key="item._id" class="border-b hover:bg-gray-100 transition">
            <td class="px-4 py-1">{{ idx + 1 + (currentPage - 1) * limit }}</td>
            <td class="">
              <img
                :src="item.background_url || require('@/assets/images/No-image.png')"
                class="rounded-md object-cover my-1"
                style="width: 90px; height: 60px"
              />
            </td>
            <td class="px-4 py-1 font-medium text-gray-800">{{ item.title }}</td>
            <td
              class="px-4 py-1 text-center"
              :title="item.missingLanguages.length > 0 ? `Missing: ${item.missingLanguages.join(', ')}` : 'All languages available'"
            >
              <div class="flex items-center justify-center gap-2">
                <span class="text-gray-500 text-lg">{{ item.app_language }}</span>
                <span
                  v-if="item.languageCount && item.missingLanguages && item.app_language === 'EN'"
                  :class="[
                    'inline-flex items-center px-2 py-1 rounded-full font-semibold cursor-pointer',
                    item.languageCount - item.missingLanguages.length !== 11 ? 'bg-red-900 text-white' : 'bg-blue-900 text-white',
                  ]"
                >
                  {{ item.languageCount - item.missingLanguages.length }}/{{ item.languageCount }}
                </span>
                <span v-if="item.app_language === 'EN'" class="material-icons text-gray-400 cursor-pointer" style="font-size: 20px">info</span>
              </div>
            </td>
            <td class="px-4 py-1 text-center font-semibold text-gray-700">{{ formatDate(item.start_date) }} - {{ formatDate(item.end_date) }}</td>
            <td class="px-4 py-1 text-center">
              <span
                :class="item.is_active ? 'bg-green-500 text-white' : 'bg-gray-200 text-gray-500'"
                class="inline-block px-3 py-1 rounded-full font-semibold"
              >
                {{ item.is_active ? "Active" : "Inactive" }}
              </span>
            </td>
            <td class="px-4 py-1">
              <vs-dropdown>
                <svg class="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <circle cx="12" cy="5" r="1.5" />
                  <circle cx="12" cy="12" r="1.5" />
                  <circle cx="12" cy="19" r="1.5" />
                </svg>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="editingData(item)"> <vs-icon icon="create" class="align-right" /> Edit </vs-dropdown-item>
                  <vs-dropdown-item
                    @click="
                      deletePromotionDataPopup = true;
                      dataToDelete = item._id;
                    "
                  >
                    <vs-icon icon="delete_sweep" /> Delete
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </td>
          </tr>
          <tr v-if="!promotionData || promotionData.length === 0">
            <td colspan="12" class="text-center h-full py-6 text-gray-400">No promotions found.</td>
          </tr>
        </tbody>
      </table>
      <!-- Pagination -->
      <div class="flex flex-col md:flex-row items-center justify-between mt-3 pr-3">
        <div class="invisible">
          <span>asd</span>
        </div>
        <div class="flex justify-center items-center">
          <vs-pagination v-model="currentPage" :total="totalPages" :limit="1" @change="fetchAllPromotionData" class="my-2" />
        </div>
        <div class="flex items-center gap-2 text-sm mt-2 md:mt-0">
          <span>Show Records:</span>
          <vs-select v-model="limit" @change="fetchAllPromotionData" class="w-20" :color="'#6366f1'">
            <vs-select-item value="25" text="25" />
            <vs-select-item value="50" text="50" />
            <vs-select-item value="100" text="100" />
          </vs-select>
        </div>
      </div>
      <!-- Edit or Add Data Popup  -->
      <vs-popup :title="isNew ? 'Add New Promotion' : 'Edit Promotion'" :active.sync="defaultalert">
        <vs-row>
          <vs-col vs-lg="12" vs-xs="12">
            <div class="flex items-center justify-between">
              <vs-select
                v-if="!isNew"
                label="Language"
                v-model="singleDataDetails.app_language"
                @change="fileterusingLanguage($event, singleDataDetails)"
                icon="arrow_downward"
                :disabled="isNew == true"
                class="mb-2"
              >
                <vs-select-item value text="Choose Language" disabled />
                <vs-select-item :value="item.culture" :text="item.culture" v-for="(item, index) in languages" :key="index" />
              </vs-select>
              <div v-if="!isNew && singleDataDetails.app_language === 'EN'" :title="'Toggle to update existing translations'">
                <!-- toggle pill to update existing translations -->
                <label class="block text-sm font-semibold mb-2">Update Translations</label>
                <toggle-pill v-model="singleDataDetails.translate" :disabled="showLoader" />
              </div>
            </div>
          </vs-col>

          <vs-col vs-lg="12" vs-xs="12">
            <vs-input label="Enter Title" v-model="singleDataDetails.title" />
          </vs-col>
          <vs-col vs-lg="12" vs-xs="12">
            <vs-input label="Enter Description" v-model="singleDataDetails.description" />
          </vs-col>
          <vs-col vs-lg="6" vs-xs="6">
            <vs-input label="Enter Price" type="number" :min="0" onwheel="this.blur()" v-model="singleDataDetails.price" />
          </vs-col>
          <vs-col vs-lg="6" vs-xs="6">
            <vs-input label="Enter Discounted Price" type="number" :min="0" onwheel="this.blur()" v-model="singleDataDetails.discount_price" />
          </vs-col>
          <vs-col vs-lg="6" vs-xs="6">
            <vs-input label="Enter Start Date" type="date" v-model="singleDataDetails.start_date" />
          </vs-col>
          <vs-col vs-lg="6" vs-xs="6">
            <vs-input label="Enter End Date" type="date" v-model="singleDataDetails.end_date" />
          </vs-col>
          <vs-col vs-lg="6" vs-xs="12">
            <vs-input label="Enter Forwad Link URL" type="url" v-model="singleDataDetails.link_url" />
          </vs-col>
          <vs-checkbox v-model="singleDataDetails.is_active">Status (Active / Inactive)</vs-checkbox>

          <vs-col vs-lg="12" vs-xs="12" class="mb15 mt20">
            <div class="flex justify-between items-start">
              <label class="block text-sm font-semibold">Image</label>
              <button
                v-if="displayImage"
                type="button"
                color="danger"
                class="bg-red-500 p-1 h-6 rounded-md hover:bg-red-700 transition text-white"
                @click="clearImage"
                :disabled="showLoader"
              >
                Clear
              </button>
            </div>
            <div
              class="flex flex-col items-center justify-center border-2 border-dashed rounded-md cursor-pointer bg-gray-50 hover:bg-gray-100 transition"
              style="width: 100%; height: 140px; min-height: 140px"
              @dragover.prevent
              @dragenter.prevent
              @drop.prevent="onDropImage"
              @click="triggerFileInput"
            >
              <img v-if="displayImage" :src="displayImage" class="rounded-md object-cover border" style="width: 200px; max-height: 140px" />
              <div v-else class="flex flex-col items-center justify-center w-full h-full text-gray-400">
                <span class="material-icons" style="font-size: 32px">cloud_upload</span>
                <span>Drag & Drop or Click to Upload</span>
              </div>
              <input
                type="file"
                ref="fileInput"
                class="hidden"
                @change="onImageChange"
                accept="image/jpeg,image/jpg,image/webp"
                :disabled="showLoader"
              />
            </div>
          </vs-col>
          <!-- independent language to translate -->
          <vs-col vs-lg="12" vs-xs="12" class="mb-3">
            <div class="pt-2" v-if="isNew && singleDataDetails.app_language === 'EN'">
              <label class="block text-sm font-semibold mb-2">Choose Languages to Translate</label>
              <div class="grid grid-cols-7 gap-2">
                <vs-checkbox v-model="selectAllLang" @change="toggleSelectAll" :disabled="showLoader" class="z-0">All</vs-checkbox>
                <div v-for="lang in languages" :key="lang.culture">
                  <vs-checkbox
                    :value="singleDataDetails.languagesToTranslate.includes(lang.culture)"
                    @change="toggleLanguage(lang.culture)"
                    :disabled="lang.culture === 'EN' || showLoader"
                    class="z-0"
                  >
                    {{ lang.culture }}
                  </vs-checkbox>
                </div>
              </div>
            </div>
            <!-- add missing languages -->
            <div
              v-if="
                !isNew &&
                singleDataDetails.app_language === 'EN' &&
                singleDataDetails.missingLanguages &&
                singleDataDetails.missingLanguages.length > 0
              "
            >
              <label class="block text-sm font-semibold pt-1 mb-2">Add missing translations</label>
              <vs-checkbox v-model="singleDataDetails.translateMissing" :disabled="showLoader">Add missing translations</vs-checkbox>
              <div v-if="singleDataDetails.translateMissing" class="grid grid-cols-7 gap-2 mt-3">
                <vs-checkbox v-model="selectAllEdit" @change="toggleSelectAllEdit" :disabled="showLoader" class="z-0">All</vs-checkbox>
                <div v-for="lang in singleDataDetails.missingLanguages" :key="lang">
                  <vs-checkbox
                    :value="singleDataDetails.languagesToTranslate.includes(lang) && lang !== 'EN'"
                    :disabled="lang === 'EN' || showLoader"
                    @change="toggleLanguage(lang)"
                    class="z-0"
                  >
                    {{ lang }}
                  </vs-checkbox>
                </div>
              </div>
            </div>
          </vs-col>

          <div class="flex flex-col md:flex-row gap-2 w-full">
            <vs-button :loading="showLoader" color="primary" type="filled" class="flex-1" icon="save" @click="addPromotionData" v-if="isNew">
              {{ singleDataDetails.languagesToTranslate.length > 1 ? "Save and Translate" : isNew ? "Save English" : "Update one" }}
            </vs-button>

            <!-- <vs-button :loading="showLoader" color="primary" type="filled" class="flex-1" icon="save" @click="addPromotionData">{{
              isNew ? "Save English" : "Update one"
            }}</vs-button>
            <vs-button :loading="showLoader" color="primary" type="filled" class="flex-1" icon="save" v-if="isNew" @click="createAndTranslate"
              >Save and Translate</vs-button
            > -->
            <vs-button
              :loading="showLoader"
              color="primary"
              type="filled"
              class="flex-1"
              icon="save"
              @click="addPromotionData"
              v-if="!isNew && !singleDataDetails.translateMissing"
            >
              Update current
            </vs-button>
            <vs-button
              :loading="showLoader"
              color="primary"
              type="filled"
              class="flex-1"
              v-if="!isNew && singleDataDetails.app_language === 'EN'"
              icon="save"
              @click="updateAndTranslate"
            >
              {{
                singleDataDetails.translateMissing
                  ? "Update and Translate Missing"
                  : singleDataDetails.translate
                  ? "Update and Translate"
                  : "Update all"
              }}
            </vs-button>
          </div>
        </vs-row>
      </vs-popup>
      <!-- Delete Confirmation Popup -->
      <vs-popup title="Delete Promotion" :active.sync="deletePromotionDataPopup">
        <p class="mb-4 text-lg text-gray-700">Are you sure you want to delete this promotion?</p>
        <div class="flex justify-end gap-2">
          <vs-button color="warning" @click="deletePromotionData">Delete</vs-button>
          <vs-button color="primary" @click="deletePromotionDataPopup = false">Cancel</vs-button>
        </div>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import api from "@/rest.js";
import { API } from "@/common/constants";
import moment from "moment";
import Vue from "vue";
import VPopover from "vue-js-popover";
import TogglePill from "../components/Common/TogglePill.vue";

Vue.use(VPopover, { tooltip: true });

export default {
  name: "BhaktiPromotion",
  components: {
    TogglePill,
  },
  data: () => ({
    title: "",
    colorx: "#0D2144",
    defaultalert: false,
    isNew: true,
    languages: [],
    fileName: "",
    search: {
      start_date: null,
      end_date: null,
      is_active: "",
      app_language: "EN",
    },
    currentPage: 1,
    totalPages: 1,
    limit: 25,
    promotionData: [],
    singleDataDetails: {
      title: "",
      background_url: "",
      description: "",
      price: "",
      discount_price: "",
      start_date: moment.utc(new Date()).format("YYYY-MM-DD"),
      end_date: moment.utc(new Date()).format("YYYY-MM-DD"),
      link_url: "",
      is_active: true,
      app_language: "EN",
      translate: false,
      languagesToTranslate: [],
      translateMissing: false,
    },
    displayImage: "",
    selectAllLang: false,
    selectAllEdit: false,
    deletePromotionDataPopup: false,
    dataToDelete: "",
    datatoEdit: "",
    showLoader: false,
  }),
  methods: {
    toggleSelectAll() {
      if (this.selectAllLang) {
        this.singleDataDetails.languagesToTranslate = this.languages.map((lang) => lang.culture);
      } else {
        this.singleDataDetails.languagesToTranslate = ["EN"];
      }
    },

    toggleSelectAllEdit() {
      if (this.selectAllEdit) {
        this.singleDataDetails.languagesToTranslate = this.singleDataDetails.missingLanguages;
      } else {
        this.singleDataDetails.languagesToTranslate = ["EN"];
      }
    },

    toggleLanguage(culture) {
      const selectedLanguages = this.singleDataDetails.languagesToTranslate;

      if (selectedLanguages.includes(culture)) {
        this.singleDataDetails.languagesToTranslate = selectedLanguages.filter((lang) => lang !== culture);
      } else {
        this.singleDataDetails.languagesToTranslate = [...selectedLanguages, culture];
      }

      const allLanguagesSelected = this.languages.every((lang) => this.singleDataDetails.languagesToTranslate.includes(lang.culture));
      this.selectAllLang = allLanguagesSelected;
      if (this.selectAllEdit) {
        const allLanguagesSelected = this.singleDataDetails.missingLanguages.every((lang) =>
          this.singleDataDetails.languagesToTranslate.includes(lang)
        );
        this.selectAllEdit = allLanguagesSelected;
      }
    },

    OpenAddDataModal() {
      this.clearImage();
      this.$data.defaultalert = true;
      this.$data.isNew = true;
      this.$data.singleDataDetails = {
        title: "",
        background_url: "",
        description: "",
        price: "",
        discount_price: "",
        start_date: moment.utc(new Date()).format("YYYY-MM-DD"),
        end_date: moment.utc(new Date()).format("YYYY-MM-DD"),
        link_url: "",
        is_active: false,
        app_language: "EN",
        languagesToTranslate: ["EN"],
        translateMissing: false,
        translate: false,
      };
      this.selectAllEdit = false;
      this.selectAllLang = false;
      this.$data.displayImage = "";
    },

    editingData(i) {
      this.$data.isNew = false;
      this.$data.singleDataDetails = Object.assign(this.singleDataDetails, i);
      this.$data.singleDataDetails.languagesToTranslate = ["EN"];
      this.$data.singleDataDetails.translateMissing = false;
      this.$data.singleDataDetails.translate = false;
      this.$data.defaultalert = true;
      this.$data.displayImage = i.background_url;
      this.$data.singleDataDetails.start_date = moment.utc(new Date(i.start_date)).format("YYYY-MM-DD");
      this.$data.singleDataDetails.end_date = moment.utc(new Date(i.end_date)).format("YYYY-MM-DD");
    },

    triggerFileInput() {
      if (this.$refs.fileInput) this.$refs.fileInput.click();
    },

    onDropImage(e) {
      const files = e.dataTransfer.files;
      if (files && files[0]) {
        this.onImageChange({ target: { files } });
      }
    },

    onImageChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.singleDataDetails.background_url = file;
        this.displayImage = URL.createObjectURL(file);
      }
    },

    clearImage() {
      this.displayImage = "";
      this.singleDataDetails.background_url = "";
      if (this.$refs.fileInput) this.$refs.fileInput.value = null;
    },

    async resetData() {
      this.$data.search = {
        start_date: null,
        end_date: null,
        is_active: "",
        app_language: "EN",
      };
      await this.fetchAllPromotionData();
    },

    formatDate: function (date) {
      return moment.utc(date).format("DD/MM/YYYY");
    },

    async fetchAllPromotionData() {
      if (this.$data.search.start_date && !this.$data.search.end_date) {
        return;
      }
      this.$vs.loading();
      try {
        const r = await api.get(`${API.GET_PROMOTION_DATA}?page=${this.currentPage}&limit=${this.limit}`, {
          params: {
            start_date: this.$data.search.start_date,
            end_date: this.$data.search.end_date,
            is_active: this.$data.search.is_active,
            app_language: this.$data.search.app_language,
          },
        });

        if (r.status === 200) {
          if (this.$data.search.app_language === "EN") {
            for (const item of r.data.data) {
              item.tooltipContent =
                item.missingLanguages.length > 0 ? "Missing Languages: " + item.missingLanguages.join(", ") : "All Languages are translated";
            }
          }

          this.$data.promotionData = r.data.data;
          this.totalPages = Math.ceil(r.data.totalCount / this.limit);
          const targetId = this.$route.query.id;
          if (targetId) {
            const targetData = this.$data.promotionData.find((item) => item._id === targetId);
            if (targetData) {
              this.editingData(targetData);
            }
          }
        }
      } catch (error) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Error",
          text: error.message || "Failed to fetch promotion data",
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    async uploadImage(data) {
      const imageType = ["image/jpeg", "image/jpg", "image/webp"];
      let isValid = false;
      if (!data || !data.target || !data.target.files || !data.target.files[0]) return;
      isValid = imageType.indexOf(data.target.files[0].type) > -1;

      if (!isValid) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "Only JPEG,JPG,WEBP Image files formats should be supported",
          color: "danger",
          position: "top-right",
        });
        if (this.singleDataDetails.background_url instanceof File) this.$refs.fileInput.value = null;
        throw new Error("Invalid file type");
      }
      if (data.target.files[0].size > 500000) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "File size should be less than 500kb",
          color: "danger",
          position: "top-right",
        });
        throw new Error("File size exceeds limit");
      }

      let formdata = new FormData();
      this.$data.fileName = data.target.files[0].name;
      formdata.append("bhaktiPromotion", this.$data.singleDataDetails.title);
      formdata.append("file", data.target.files[0]);
      this.$vs.loading();

      try {
        const response = await api.post(API.UPLOAD_IMAGE, formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        if (response.data.error != null) {
          this.$vs.notify({
            title: "Uploading Error",
            text: response.data.error.message,
            color: "danger",
            position: "top-right",
          });
        } else {
          this.$data.displayImage = response.data.files[0].url;
          this.$vs.notify({
            text: "File Uploaded",
            color: "success",
            position: "top-right",
          });
          if (this.singleDataDetails.background_url instanceof File) this.$refs.fileInput.value = null;
          this.$emit("input", response);
        }
      } catch (error) {
        this.$vs.notify({
          text: "File Uploading Failed",
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    async addPromotionData() {
      if (this.$data.singleDataDetails.languagesToTranslate.length > 1 && this.$data.isNew) return await this.createAndTranslate();

      this.$vs.loading();
      try {
        if (this.singleDataDetails.background_url instanceof File)
          await this.uploadImage({ target: { files: [this.$data.singleDataDetails.background_url] } });

        const promotionData = {
          background_url: this.$data.displayImage,
          title: this.$data.singleDataDetails.title,
          description: this.$data.singleDataDetails.description,
          link_url: this.$data.singleDataDetails.link_url,
          start_date: new Date(this.$data.singleDataDetails.start_date).toISOString(),
          end_date: new Date(this.$data.singleDataDetails.end_date).toISOString(),
          is_active: this.$data.singleDataDetails.is_active,
          price: parseInt(this.$data.singleDataDetails.price),
          discount_price: parseInt(this.$data.singleDataDetails.discount_price),
          app_language: this.$data.singleDataDetails.app_language,
          languagesToTranslate: this.$data.singleDataDetails.languagesToTranslate,
        };

        let r;
        if (this.$data.isNew === true) {
          r = await api.post(`${API.ADD_PROMOTION_DATA}`, promotionData);
          if (r.status === 200) {
            this.$vs.notify({
              title: "Added Promotion Data",
              text: "Added Promotion Data",
              color: "success",
              position: "top-right",
            });
          }
        } else {
          r = await api.put(`${API.EDIT_PROMOTION_DATA}/${this.singleDataDetails._id}`, promotionData);
          if (r.status === 200) {
            this.$vs.notify({
              title: "Edited Promotion Data",
              text: "Edited Promotion Data",
              color: "success",
              position: "top-right",
            });

            if (this.$route.query.id) this.$router.push({ path: "/calendar" });
          }
        }

        this.$data.defaultalert = false;
        this.resetData();
        await this.fetchAllPromotionData();
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: error.message || "Operation failed",
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    async createAndTranslate() {
      this.$data.showLoader = true;
      this.$data.defaultalert = false;

      try {
        if (this.singleDataDetails.background_url instanceof File)
          await this.uploadImage({ target: { files: [this.$data.singleDataDetails.background_url] } });

        const promotionData = {
          background_url: this.$data.displayImage,
          title: this.$data.singleDataDetails.title,
          description: this.$data.singleDataDetails.description,
          link_url: this.$data.singleDataDetails.link_url,
          start_date: new Date(this.$data.singleDataDetails.start_date).toISOString(),
          end_date: new Date(this.$data.singleDataDetails.end_date).toISOString(),
          is_active: this.$data.singleDataDetails.is_active,
          price: parseInt(this.$data.singleDataDetails.price),
          discount_price: parseInt(this.$data.singleDataDetails.discount_price),
          app_language: this.$data.singleDataDetails.app_language,
          languagesToTranslate: this.$data.singleDataDetails.languagesToTranslate,
        };

        const res = await api.post(API.C_AND_T_PROMOTION_DATA, promotionData);

        if (res.status === 200) {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Added Promotion Data",
            text: "Added Promotion Data",
            color: "success",
            position: "top-right",
          });
        }

        this.$data.defaultalert = false;
        this.resetData();
        await this.fetchAllPromotionData();
      } catch (error) {
        this.$vs.notify({
          title: "Could not create/translate Data",
          text: "Could not create/translate Data",
          color: "danger",
          position: "top-right",
        });
        throw error;
      } finally {
        this.$data.showLoader = false;
        this.$vs.loading.close();
      }
    },

    async updateAndTranslate() {
      this.$data.showLoader = true;

      try {
        if (this.singleDataDetails.background_url instanceof File)
          await this.uploadImage({ target: { files: [this.$data.singleDataDetails.background_url] } });

        const promotionData = {
          background_url: this.$data.displayImage,
          title: this.$data.singleDataDetails.title,
          description: this.$data.singleDataDetails.description,
          link_url: this.$data.singleDataDetails.link_url,
          start_date: new Date(this.$data.singleDataDetails.start_date).toISOString(),
          end_date: new Date(this.$data.singleDataDetails.end_date).toISOString(),
          is_active: this.$data.singleDataDetails.is_active,
          price: parseInt(this.$data.singleDataDetails.price),
          discount_price: parseInt(this.$data.singleDataDetails.discount_price),
          app_language: this.$data.singleDataDetails.app_language,
          languagesToTranslate: this.$data.singleDataDetails.languagesToTranslate,
          translate: this.$data.singleDataDetails.translate,
        };

        const r = await api.put(`${API.U_AND_T_PROMOTION_DATA}/${this.singleDataDetails._id}`, promotionData);

        if (r.status === 200) {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Edited Promotion Data",
            text: "Edited Promotion Data",
            color: "success",
            position: "top-right",
          });
          await this.fetchAllPromotionData();
          if (this.$route.query.id) this.$router.push({ path: "/calendar" });
          this.$data.defaultalert = false;
        }
      } catch (error) {
        this.$vs.notify({
          title: "Could not edit Data",
          text: "Could not edit Data",
          color: "danger",
          position: "top-right",
        });
        this.$data.showLoader = false;
        throw error;
      } finally {
        this.$data.defaultalert = false;
        this.$data.showLoader = false;
        this.resetData();
        await this.fetchAllPromotionData();
      }
    },

    async fileterusingLanguage(event, item) {
      let id = item.ref || item._id;

      if (event && id) {
        this.$vs.loading();
        try {
          const r = await api.get(API.GET_SINGLE_PROMOTION_DATA, {
            params: {
              app_language: event,
              id: id,
            },
          });

          if (r.status !== 200) throw new Error("Failed to fetch promotion data for selected language");

          this.$data.singleDataDetails = Object.assign({}, r.data);
          this.$data.displayImage = r.data.background_url;
          this.$data.singleDataDetails.start_date = moment.utc(new Date(r.data.start_date)).format("YYYY-MM-DD");
          this.$data.singleDataDetails.end_date = moment.utc(new Date(r.data.end_date)).format("YYYY-MM-DD");
        } catch (error) {
          this.$vs.notify({
            title: "Error",
            text: error.message || "Failed to fetch promotion data for selected language",
            color: "danger",
            position: "top-right",
          });
          throw error;
        } finally {
          this.$vs.loading.close();
        }
      }
    },

    async deletePromotionData() {
      this.$vs.loading();
      try {
        const r = await api.delete(`${API.DELETE_PROMOTION_DATA}/${this.$data.dataToDelete}`);
        if (r.status === 200) {
          this.$vs.notify({
            text: "Deleted Successfully",
            color: "success",
            position: "top-right",
          });
          await this.fetchAllPromotionData();
        }
      } catch (error) {
        this.$vs.notify({
          text: "Already Deleted",
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$data.deletePromotionDataPopup = false;
        this.$vs.loading.close();
      }
    },

    async fetchAllLanguages() {
      this.$vs.loading();
      try {
        const r = await api.get(API.GET_LANG, {});
        this.languages = r.data;
      } catch (error) {
        this.$vs.notify({
          text: "Error fetching languages",
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
  },

  async created() {
    await Promise.all([this.fetchAllPromotionData(), this.fetchAllLanguages()]);
    if (this.$route.query.language) {
      this.$data.search.app_language = this.$route.query.language;
      this.fetchAllPromotionData();
    }
  },
};
</script>

<style scoped>
.material-icons {
  font-family: "Material Icons";
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  direction: ltr;
  -webkit-font-smoothing: antialiased;
}
</style>
